import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { exec, isRequestSuccessed } = useRequest({
    name: 'PUT_FIRST_INSPECTION_SAMPLE',
    url: ``,
    method: 'PUT',
  });
  useEffect(() => {
    if (param&&param.id){
      exec({
        url: `/api/inspection/first/samples/${param.id}`,
        data:param
      });
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [exec,isRequestSuccessed];
});